angular.module("Main").controller("KursWartelisteBestaetigungController", ["$rootScope", "$scope", "$state", "$stateParams",
    "$localStorage", "$window", "$uibModal", "$translate", "BookingService",
    "PaymentService", "SessionService", "AuthenticationService", "DialogService",
    function ($rootScope, $scope, $state, $stateParams, $localStorage, $window, $uibModal, $translate, BookingService,
              PaymentService, SessionService, AuthenticationService, DialogService) {
        var vm = this;

        vm.optionButton = '0';
        vm.text = {};
        vm.hasBlockkurse = false;
        vm.accepted = false;
        vm.showPayments = false;
        vm.choosenPaymentMethod = null;

        if (screen.width < 600) {
            vm.isMobilePhone = true;
            vm.weekView = true
        } else {
            vm.isMobilePhone = false;
            vm.weekView = true;
        }

        vm.isApp = false;
        vm.isLoggedIn = false;
        vm.username = "";
        $localStorage.user = {};
        let uuid = false;
        let email = $stateParams.email;
        let password = $stateParams.pwd;
        let clubId = $stateParams.cid;
        if (!_.isUndefined($stateParams.id)) {
            uuid = $stateParams.id;
        }

        if (!_.isEmpty(email) && !_.isEmpty(password)) {
            AuthenticationService.login(email, password).then(function (response) {
                if (response === null) {
                    $state.go("no_access",{cid: 1, loginResponseNull: 1, loginError: 0, urlIncomplete: 0, main: 0});
                } else {
                    SessionService.setAuthData(clubId, uuid, true);
                    vm.isApp = true;
                    vm.isLoggedIn = true;
                }
            }).catch(function (error) {
                $state.go("no_access", {cid: 1, loginResponseNull: 0, loginError: 1, urlIncomplete: 0, main: 0, message: error.message});
            });
        }

        loadAppointmentInfos();
        getKursbuchungLayouKonfiguration();
        loadLandingPageBSConfig();
        loadConfigs();
        checkIfSixPaymentConfig();

        function loadAppointmentInfos() {
            BookingService.getAppointmentInfosForConfirmWaitlist($stateParams.appNr).then(function (data) {
                vm.kurs = data;
                vm.kurs.FreiePlaetze = true;
                vm.kurs.completeStart = data.Start;
                vm.kurs.completeEnde = data.Ende;
                vm.kurs.Farbe = data.Ressourcenplaner_Terminart.Farbe;
                vm.kurs.Infotext = data.Ressourcenplaner_Terminart.Ressourcenplaner_OnlineKursbuchung_Terminarts.length > 0 ? data.Ressourcenplaner_Terminart.Ressourcenplaner_OnlineKursbuchung_Terminarts[0].Infotext : null;
                vm.kurs.Bezeichnung = data.Ressourcenplaner_Terminart.Bezeichnung;
                vm.kurs.PreisZahl = data.Ressourcenplaner_Terminart.PreisZahl;
                vm.kurs.Bezahlung = data.Ressourcenplaner_Terminart.Buchungssystem_Terminarten.Bezahlung;
                vm.kurs.Leistungsarten = data.Ressourcenplaner_Terminart.TerminartNutzungsrechte;
                vm.kurs.IsSameDay = true;
                vm.kurs.Tag = new Date(data.Start);
                vm.kurs.Start = moment(data.Start).format('HH:mm').toString();
                vm.kurs.Ende = moment(data.Ende).format('HH:mm').toString();
                vm.start = new Date (data.Start);
                vm.ende = new Date (data.Ende)
                vm.kurs.AllRessources = [];
                vm.allRessources = [];
                _.forEach(data.Ressourcenplaner_JT_Termin_Ressources, function (ress) {
                    vm.allRessources.push({Mitarbeiter: ress.Mitarbeiter, Bezeichnung: ress.Ressourcenplaner_Ressource.Bezeichnung, Id: ress.Ressourcenplaner_Ressource.Nr})
                });
                let MitarbeiterRessource = _.sortBy(_.filter(vm.allRessources, {Mitarbeiter: 1}), 'Bezeichnung');
                let NichtMitarbeiterRessource = _.sortBy(_.filter(vm.allRessources, {Mitarbeiter: 0}), 'Bezeichnung');
                vm.kurs.AllRessources = _.concat(MitarbeiterRessource, NichtMitarbeiterRessource);
                vm.kurs.RessourcenIds = _.map(vm.kurs.AllRessources, 'Id')
            }).then(function () {
                BookingService.getImage(vm.kurs.Terminart_Nr).then(function (data) {
                    vm.kurs.Image = data;
                });
            }).then(function () {
                checkAppoInfos();
                checkTerminartPayments();
                if(vm.isLoggedIn)
                checkAfterLogin();
            })
        }

        function checkAppoInfos() {

            if (vm.kurs.SerienterminNr > 0 && vm.kurs.IstBlockkurs) {
                BookingService.getBlockkursTermine(vm.kurs.SerienterminNr).then(function (data) {
                    vm.hasBlockkurse = true;
                    vm.kurs.Blockkurs = data;
                    _.forEach(data, function (d) {
                        d.Tag = new Date(d.Start);
                        d.Tag = moment(d.Tag).format('YYYY-MM-DD').toString();
                        d.Start = moment(d.Start).format('HH:mm').toString();
                        d.Ende = moment(d.Ende).format('HH:mm').toString();
                    });
                })
            }
        }

        function checkAfterLogin() {
            BookingService.checkAppointmentGroupLimit(vm.kurs.Terminart_Nr,
                vm.currentUser.memberNr, vm.kurs.completeStart).then(function (limits) {
                if (limits && ((limits.day && limits.day.reached) || (limits.week && limits.week.reached) ||
                        (limits.month && limits.month.reached) || (limits.year && limits.year.reached))) {
                    vm.limits = limits;
                }
            }).catch(function () {
            });

            if (vm.kurs.Ressourcenplaner_Terminart.Buchungssystem_Terminarten.Bezahlung === 3) {
                PaymentService.getArticlePrice(vm.currentUser.uid, vm.kurs.Terminart_Nr, vm.kurs.completeStart)
                    .then(function (priceData) {
                        if (!_.isEmpty(priceData))
                            vm.kurs.PreisZahl = priceData.Price;
                    }).catch(function () {
                });
            }
        }

        function checkIfSixPaymentConfig() {
            BookingService.checkSixConfig().then(function (data) {
                vm.isSixPayment = data.paymentValid;
            })
        }

        function checkTerminartPayments() {
            BookingService.checkPayments(vm.kurs.Terminart_Nr).then(function (data) {
                vm.terminartPayments = data;
            })
        }

        var loginHandler = $rootScope.$on("login", function (event, data) {
            checkUser();
            vm.isLoggedIn = data;
        });

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
            unregisterEventHandler();
            $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        });

        // if (!SessionService.getSessionId()) {
        //     $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        // } else
        //     start();


        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            })
        }

        function loadLandingPageBSConfig() {
            BookingService.loadLandingPageBSConfig().then(function (data) {
                vm.landingPage = data;
                if (vm.landingPage.LandingPageBuchungssystem) {
                    if (window.location !== window.parent.location) {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageNewTabWithout = true;
                        } else {
                            vm.landingPageNewTabWith = true;
                        }

                        // The page is in an iframe
                    } else {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith("https", vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageWithout = true;
                        } else {
                            vm.landingPageWith = true;
                        }
                        // The page is not in an iframe
                    }
                }
            })
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.MRVerbergenKB = data.MRVerbergenKB;
                vm.NMRVerbergenKB = data.NMRVerbergenKB;
            });
        }

        $('#register-focus').autofocus;

        $scope.$on("destroy", function () {
            unregisterEventHandler();
        });

        function unregisterEventHandler() {
            loginHandler();
            logoutHandler();
        }

        function checkUser() {
            vm.isMember = $localStorage.user && $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
            vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
            vm.currentUser = $localStorage.user;
            vm.isPayPal = $localStorage.user ? $localStorage.user.isPayPal : false;
            vm.isBonitaet = $localStorage.user ? $localStorage.user.isBonitaet : false;
         loadAppointmentInfos();
        }

        vm.registerFinish = false;
        vm.booking = {};


        BookingService.loadConfigurationStammdaten().then(function (texts) {
            vm.stammdatenBestaetigung = texts.BestaetigungStammdaten;
            if (texts.TextObligatory) {
                vm.text.vb = "T_verpflichtend_buchen";
                vm.text.vbe = "T_kostenpflichtig_buchen";
                vm.text.mvb = "T_verpflichtend_buchen";
                vm.text.mvbe = "T_kostenpflichtig_buchen";
            } else {
                vm.text.vb = "T_Buchen";
                vm.text.vbe = "T_Bezahlen";
                vm.text.mvb = "T_Buchen";
                vm.text.mvbe = "T_Bezahlen";
            }
        });

        // vm.bookAsLoggedIn = function () {
        //     if (vm.kurs.IstBlockkurs) {
        //         startPaymentBlockkurs();
        //     } else
        //         startPayment();
        // };

        vm.bookAsLoggedInVorOrt = function (method) {
            if (vm.kurs.Ressourcenplaner_Terminart.IstBlockkurs) {
                bookWithoutPaymentBlockkurs(method);
            } else
                bookWithoutPayment(method);
        };

        vm.setOnWaitlist = function () {
            if (vm.kurs.Ressourcenplaner_Terminart.IstBlockkurs) {
                setOnWaitlistBlockkurs()
            } else
                setOnWaitlistKurs()
        };

        vm.openPrivacyTerms = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/privacyTerms.html",
                controller: "BookingPrivacyTermsDialogController",
                controllerAs: "vm",
                resolve: {style: vm.layoutSettings[3]}
            });
        };

        vm.loginModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/Main/views/dialogs/login.html",
                controller: "LoginDialogController",
                controllerAs: "vm",
                backdrop: "static",
                keyboard: false
            });

            modalInstance.result.then(function (data) {
                if (!_.isNil(data)) {
                    $localStorage.user = {};
                    let now = new Date;
                    let hours = 6;
                    //let minutes = 5;
                    //let ttl = minutes * 60 * 1000
                    let ttl = hours * 60 * 60 *1000;
                    vm.isLoggedIn = true;
                    vm.hideLogin = true;
                    $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                    $localStorage.user.Firstname = data.user.Firstname;
                    $localStorage.user.Lastname = data.user.Lastname;
                    $localStorage.user.isMember = data.user.IsMember;
                    $localStorage.user.memberNr = data.user.MemberNr;
                    $localStorage.user.Email = data.user.Email;
                    $localStorage.user.uid = data.user.uid;
                    $localStorage.user.isPayPal = data.user.IsPaypal;
                    $localStorage.user.isBonitaet = data.user.IsBonitaet;
                    $localStorage.user.expiryTime = now.getTime() + ttl;
                    $rootScope.$emit("login", vm.isLoggedIn);
                }
            });
        };

        /*vm.registerAndBook = function (registration) {
            vm.dataForm.salutation.$setTouched();
            vm.dataForm.firstname.$setTouched();
            vm.dataForm.lastname.$setTouched();
            vm.dataForm.email.$setTouched();
            vm.dataForm.street.$setTouched();
            vm.dataForm.zip.$setTouched();
            vm.dataForm.city.$setTouched();
            vm.dataForm.phone.$setTouched();
            vm.dataForm.mobile_nr.$setTouched();
            vm.dataForm.password.$setTouched();
            vm.dataForm.privacyterms.$setTouched();
            if (vm.dataForm.$valid) {
                registration.mobile_nr = validator.whitelist(registration.mobile_nr, "+1234567890");
                BookingService.findUser(registration.firstname, registration.email).then(function (data) {
                    if (data.IsRegistered) {
                        vm.alreadyRegistered = true;
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Loggen_sie_sich_ein";
                    } else {
                        if (!_.isEmpty(data.uid))
                            registration.PersonNr = data.uid;
                        BookingService.createTemporaryMember(registration).then(function (temporaryMember) {
                            return BookingService.sendRegistrationEmail(registration.email, temporaryMember);
                        }).then(function () {
                            vm.registerFinish = true;
                            vm.errorText = "LT_Es_wurde_email_geschickt";
                        }).catch(function () {
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten";
                        });
                    }
                }).catch(function (err) {
                    vm.errorHeader = "T_Fehler";
                    vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten";
                })
            }
        };*/


        vm.chooseLoginButton = function () {
            vm.choosenRegistration = false;
            // reset login status
            SessionService.clear("globals");
            vm.dataForm = {};
            vm.loginData = {};
            vm.isMember = false;
            vm.openFormForgotPassword = false;
            vm.wrongLoginData = false;
            vm.openFormChangePassword = false;
        };

        vm.chooseRegistrierungButton = function () {
            vm.choosenRegistration = true;
        };


        vm.login = function (email, password) {
            vm.dataForm.password.$setTouched();
            vm.dataForm.email.$setTouched();
            if (vm.dataForm.$valid) {
                AuthenticationService.login(email, password).then(function (data) {
                    if (!_.isNil(data)) {
                        vm.isLoggedIn = true;
                        vm.username = data.Firstname + " " + data.Lastname;
                        $rootScope.$emit("login", vm.isLoggedIn);
                    } else {
                        vm.wrongLoginData = true;
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Falsche_Logindaten";
                    }
                });
            }
        };

        vm.openForgotPassword = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/forgotPassword.html",
                controller: "ForgotPasswordController",
                controllerAs: "vm",
                windowClass: 'position-class',
                backdrop: "static"
            });
        };

        vm.openChangePassword = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/changePassword.html",
                controller: "ChangePasswordController",
                controllerAs: "vm",
                windowClass: 'position-class',
                backdrop: "static"
            });
        };

        vm.registerModal = function () {
            DialogService.openRegisterDialog().catch(function () {
            });
        };

        vm.loginResgister = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/Main/views/dialogs/login.html",
                controller: "LoginDialogController",
                controllerAs: "vm",
                backdrop: "static",
                keyboard: false
            });

            modalInstance.result.then(function (data) {
                if (!_.isNil(data)) {
                    $localStorage.user = {};
                    let now = new Date;
                    let hours = 6;
                    //let minutes = 5;
                    //let ttl = minutes * 60 * 1000
                    let ttl = hours * 60 * 60 *1000;
                    vm.isLoggedIn = true;
                    vm.hideLogin = true;
                    $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                    $localStorage.user.Firstname = data.user.Firstname;
                    $localStorage.user.Lastname = data.user.Lastname;
                    $localStorage.user.isMember = data.user.IsMember;
                    $localStorage.user.memberNr = data.user.MemberNr;
                    $localStorage.user.Email = data.user.Email;
                    $localStorage.user.uid = data.user.uid;
                    $localStorage.user.isPayPal = data.user.IsPaypal;
                    $localStorage.user.isBonitaet = data.user.IsBonitaet;
                    $localStorage.user.expiryTime = now.getTime() + ttl;
                    $rootScope.$emit("login", vm.isLoggedIn);
                }
            });
        };

        function bookPayPal() {
            var tempBooking = {
                PersonNr: vm.currentUser.memberNr,
                TerminartNr: vm.kurs.Ressourcenplaner_Terminart.Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: $stateParams.appNr,
                Artikel: vm.kurs.Ressourcenplaner_Terminart.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcenIds,
                Leistungsarten: vm.kurs.Leistungsarten,
                LinkId: $stateParams.id,
                OnlyBookInto: true,
                MitgliedsOption: vm.kurs.MitgliedsOptionKurse
            };
            PaymentService.startKursPayPal(tempBooking).then(function (url) {
                unregisterEventHandler();
                $window.location.href = url.redirectUrl;
            }).catch(function (error) {
                if (error.status === 489) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true
                    });
                }
                else if (error.status === 488) {
                    unregisterEventHandler();
                    $state.go("payment_member_to_late", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        message: error.data.message,
                        isKurs: true
                    });

                }
                else if (error.status === 500) {
                    unregisterEventHandler();
                    $state.go("payment_pp_error_kurs", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(),oid: error.data.oid, isKurs: true});
                } else {
                    unregisterEventHandler();
                    $state.go("payment_pp_fail_kurs", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: error.data.oid,
                        isKurs: true
                    });
                }
            })
        }

        function bookPayPalBlockkurs() {
            let userData = $localStorage.user;
            var tempBooking = {
                // PersonNr: vm.currentUser.memberNr,
                PersonNr: userData.uid,
                TerminartNr: vm.kurs.Ressourcenplaner_Terminart.Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: $stateParams.appNr,
                Artikel: vm.kurs.Ressourcenplaner_Terminart.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcenIds,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionBlockkurse,
                LinkId: $stateParams.id,
                OnlyBookInto: true
            };

            PaymentService.startPayPalBlockkurs(tempBooking).then(function (url) {
                unregisterEventHandler();
                $window.location.href = url.redirectUrl;
            }).catch(function (error) {
                if (error.status === 489) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true
                    });
                }
                else if (error.status === 488) {
                    unregisterEventHandler();
                    $state.go("payment_member_to_late", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        message: error.data.message,
                        isKurs: true
                    });
                }
                else if (error.status === 500) {
                    unregisterEventHandler();
                    $state.go("payment_pp_error_kurs", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), oid: error.data.oid, isKurs: true});
                } else {
                    unregisterEventHandler();
                    $state.go("payment_pp_fail_kurs", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: error.data.oid,
                        isKurs: true
                    });
                }
            });
        }


        function bookSix() {
            var tempBooking = {
                PersonNr: vm.currentUser.memberNr,
                TerminartNr: vm.kurs.Ressourcenplaner_Terminart.Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: $stateParams.appNr,
                Artikel: vm.kurs.Ressourcenplaner_Terminart.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcenIds,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionKurse,
                LinkId: $stateParams.id,
                OnlyBookInto: true
            };

            PaymentService.startPaymentKurs(tempBooking).then(function (url) {
                unregisterEventHandler();
                $window.location.href = url.redirectUrl;
            }).catch(function (reason) {
                if (reason.status === 410) {
                    vm.reservationError = true;
                } else if (reason.status === 406) {
                    vm.paymentError = true;
                } else if (reason.status === 400) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true
                    });
                } else {
                    unregisterEventHandler();
                    $state.go("payment_error_kurs", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), isKurs: true});
                }
            });
        }

        function bookSixBlockkurs() {
            let userData = $localStorage.user;
            var tempBooking = {
                // PersonNr: vm.currentUser.memberNr,
                PersonNr: userData.uid,
                TerminartNr: vm.kurs.Ressourcenplaner_Terminart.Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: $stateParams.appNr,
                Artikel: vm.kurs.Ressourcenplaner_Terminart.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcenIds,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionBlockkurse,
                LinkId: $stateParams.id,
                OnlyBookInto: true
            };

            PaymentService.startPaymentBlockkurs(tempBooking).then(function (url) {
                unregisterEventHandler();
                $window.location.href = url.redirectUrl;
            }).catch(function (reason) {
                if (reason.status === 410) {
                    vm.reservationError = true;
                } else if (reason.status === 406) {
                    vm.paymentError = true;
                } else if (reason.status === 400) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true
                    });
                } else {
                    unregisterEventHandler();
                    $state.go("payment_error_kurs", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), isKurs: true});
                }
            });
        }

        function bookWithoutPaymentBlockkurs(method) {
            let userData = $localStorage.user;
            var tempBooking = {
                // PersonNr: vm.currentUser.memberNr,
                PersonNr: userData.uid,
                TerminartNr: vm.kurs.Ressourcenplaner_Terminart.Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: $stateParams.appNr,
                Artikel: vm.kurs.Ressourcenplaner_Terminart.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcenIds,
                Zahlart: _.upperCase(method),
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionBlockkurse,
                OnlyBookInto: true
            };
            BookingService.createBookingBlockkurs(tempBooking).then(function (data) {
                unregisterEventHandler();
                $state.go('booking_success_kurs', {
                    cid: SessionService.getAuthData(),
                    id: SessionService.getAuthIdData(),
                    locale: true,
                    oid: data.oid,
                    bNr: data.bNr,
                    isKurs: true,
                    isBlock: true
                });
            }).catch(function (error) {
                let orderId = (_.isNil(error.data.orderId)) ? null : error.data.orderId;
                BookingService.deleteMemberFromAppointment(orderId).catch(function () {
                });
                if (error.status === 410) {
                    vm.reservationError = true;
                } else if (error.status === 406) {
                    vm.paymentError = true;
                } else if (error.status === 400) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true
                    });
                } else {
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), oid: error.data.oid, isKurs: true});
                }
            })
        }

        function bookWithoutPayment(method) {

            let userData = $localStorage.user;
            var tempBooking = {
                // PersonNr: vm.currentUser.memberNr,
                PersonNr: userData.uid,
                TerminartNr: vm.kurs.Ressourcenplaner_Terminart.Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: $stateParams.appNr,
                Artikel: vm.kurs.Ressourcenplaner_Terminart.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcenIds,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionKurse,
                Zahlart: _.upperCase(method),
                OnlyBookInto: true
            };
            BookingService.createBookingKurs(tempBooking).then(function (orderId) {
                unregisterEventHandler();
                $state.go('booking_success_kurs', {
                    cid: SessionService.getAuthData(),
                    id: SessionService.getAuthIdData(),
                    locale: true,
                    oid: orderId,
                    isKurs: true
                });
            }).catch(function (error) {
                let orderId = (_.isNil(error.data.orderId)) ? null : error.data.orderId;
                BookingService.deleteMemberFromAppointment(orderId).catch(function () {
                });
                if (error.status === 410) {
                    vm.reservationError = true;
                } else if (error.status === 406) {
                    vm.paymentError = true;
                } else if (error.status === 400) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true,
                        message: error.data.message,
                        start: error.data.start,
                        ende: error.data.ende,
                        name: error.data.name
                    });
                } else {
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), isKurs: true});
                }
            })
        }

        function setOnWaitlistBlockkurs() {
            let userData = $localStorage.user;
            var tempBooking = {
                PersonNr: vm.currentUser.memberNr,
                TerminartNr: vm.kurs.Ressourcenplaner_Terminart.Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: $stateParams.appNr,
                Artikel: vm.kurs.Ressourcenplaner_Terminart.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcenIds,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionBlockkurse,
                uid: userData.uid
            };
            BookingService.setOnWaitlistBlockkurs(tempBooking).then(function () {
                unregisterEventHandler();
                $state.go('success_waitlist', {
                    cid: SessionService.getAuthData(),
                    id: SessionService.getAuthIdData(),
                    locale: true,
                    isKurs: true,
                    isBlock: true
                });
            }).catch(function (error) {
                if (error.status === 410) {
                    vm.reservationError = true;
                } else if (error.status === 406) {
                    vm.paymentError = true;
                } else if (error.status === 409) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true
                    });
                } else {
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), isKurs: true});
                }
            })
        }

        function setOnWaitlistKurs() {
            let userData = $localStorage.user;
            var tempBooking = {
                PersonNr: vm.currentUser.memberNr,
                TerminartNr: vm.kurs.Ressourcenplaner_Terminart.Nr,
                Start: vm.kurs.completeStart,
                Ende: vm.kurs.completeEnde,
                Language: $translate.use(),
                TerminNr: $stateParams.appNr,
                Artikel: vm.kurs.Ressourcenplaner_Terminart.Bezeichnung,
                RessourcenIds: vm.kurs.RessourcenIds,
                Leistungsarten: vm.kurs.Leistungsarten,
                MitgliedsOption: vm.kurs.MitgliedsOptionKurse,
                uid: userData.uid
            };
            BookingService.setOnWaitlistKurs(tempBooking).then(function () {
                unregisterEventHandler();
                $state.go('success_waitlist', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), locale: true, isKurs: true});
            }).catch(function (error) {
                if (error.status === 410) {
                    vm.reservationError = true;
                } else if (error.status === 406) {
                    vm.paymentError = true;
                } else if (error.status === 400) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        isKurs: true
                    });
                } else {
                    unregisterEventHandler();
                    $state.go("booking_kurs_error", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), isKurs: true});
                }
            })
        }

        vm.showPaymentMethods = function () {
            vm.showPayments = true;
        };

        vm.payNow = function (method) {
            if (method === 'pp') {
                if (vm.kurs.IstBlockkurs) {
                    bookPayPalBlockkurs();
                } else
                    bookPayPal();

            }
            if (method === 'six') {
                if (vm.kurs.IstBlockkurs) {
                    bookSixBlockkurs();
                } else
                    bookSix();
            }
            if (method === 'ls' || method === 'bar') {
                if (vm.kurs.IstBlockkurs) {
                    bookWithoutPaymentBlockkurs(method)
                } else
                    bookWithoutPayment(method);
            }
        }

    }]);